import escape from 'lodash/escape'

import { Fragment } from 'common/components/topics/interfaces'
import { replaceNewLineEmojiAsLineBreak } from 'common/variantsUtils'

import styles from './string.module.css'

const colors = ['bg-maroon-200', 'bg-amber-200', 'bg-green-200', 'bg-blue-200']

export const capitalizeFirstLetter = (value) => {
  return value.charAt(0).toUpperCase() + value.slice(1)
}

export function highlightTextFragments(
  controlText: string,
  fragments?: Fragment[]
): string {
  if (!fragments) {
    return controlText
  }
  let enhancedText = escape(controlText)

  if (fragments.length > 0) {
    const placeholders: string[] = []

    fragments.forEach(({ name }, index) => {
      if (name) {
        const escapedName = name.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
        const placeholder = `__FRAGMENT_${index}__`
        placeholders.push(placeholder)

        const startsWithWord = /^\w/.test(name)
        const endsWithWord = /\w$/.test(name)
        const pattern =
          startsWithWord && endsWithWord ? `\\b${escapedName}\\b` : escapedName

        enhancedText = enhancedText.replace(
          new RegExp(pattern, 'g'),
          placeholder
        )
      }
    })

    placeholders.forEach((placeholder, index) => {
      if (fragments[index]?.name) {
        const colorClass = colors[index % colors.length]
        const highlightedText = replaceNewLineEmojiAsLineBreak(
          fragments[index].name
        )

        enhancedText = enhancedText.replace(
          placeholder,
          `<span class="${colorClass} ${styles.highlight}">${highlightedText}</span>`
        )
      }
    })
  } else {
    enhancedText = replaceNewLineEmojiAsLineBreak(enhancedText)
  }

  return `<p class="${styles.sentence}">${enhancedText}</p>`
}

export function containsRtlChars(text: string | undefined): boolean {
  const rtlScriptRegex =
    /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u0590-\u05FF]/
  return text ? rtlScriptRegex.test(text) : false
}
